module.exports = __webpack_public_path__ + "img/class8.cecec85e.png";